import { render, staticRenderFns } from "./CustomerSearchDialog.vue?vue&type=template&id=13b964f6&scoped=true"
import script from "./CustomerSearchDialog.vue?vue&type=script&lang=js"
export * from "./CustomerSearchDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerSearchDialog.vue?vue&type=style&index=0&id=13b964f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b964f6",
  null
  
)

export default component.exports